const MailToUsers = ['jkipp'];
const MailCCUsers = ['kgronsky', 'mmampara', 'slawler'];
const MailToDomain = 'dewberry.com';

function getMailToHRef(
  stateSchema,
  assetName,
  latLonString,
  xsID,
  triggerID,
  publicNote
) {
  let mailtoEncode = encodeURIComponent(
    MailToUsers.map((text) => text + `@${MailToDomain}`).join(';')
  );
  let ccEncode = encodeURIComponent(
    MailCCUsers.map((text) => text + `@${MailToDomain}`).join(';')
  );

  let fieldsVals = [
    `state=${stateSchema}`,
    `asset_name=${assetName}`,
    `latLon=${latLonString}`,
    `trigger_id=${triggerID}`,
    `xs_id=${xsID}`,
    `public_note=${publicNote ? publicNote.trim() : ''}`
  ];

  let fieldsValsStr = fieldsVals.join('\n');

  let subject = `FCastUserMsg: ${stateSchema}; ${assetName}`;
  let body = `---- Autofilled Point Info Below ----\n\n${fieldsValsStr}\n\n---- User Message Below ----\n\n`;
  let href = `mailto:${mailtoEncode}?cc=${ccEncode}&subject=${encodeURIComponent(
    subject
  )}&body=${encodeURIComponent(body)}`;
  return href;
}

export default function EmailButton({
  stateSchema,
  locationIDs,
  latLon,
  publicNote
}) {
  let mailToHRef = '#0'; // no-op
  let buttonText = 'Select Point to Enable';
  let className = 'mailButton';

  if (stateSchema && locationIDs && latLon) {
    mailToHRef = getMailToHRef(
      stateSchema,
      locationIDs.asset,
      `${latLon[0]}, ${latLon[1]}`,
      locationIDs.xs_id,
      locationIDs.trigger_id,
      publicNote
    );
    buttonText = 'Feedback';
    className += ' mailButtonEnabled';
  }

  return (
    <div className='mail'>
      <a href={mailToHRef}>
        <input className={className} type='button' value={buttonText}></input>
      </a>
    </div>
  );
}
